/* @ngInject */
export function SafetyPlanActionsFactory(SafetyPlanService, $state) {
    return {
        getDocumentLocations: function(filter) {
            return function(dispatch) {
                SafetyPlanService
                    .getLocationsForDocument(
                        $state.params.documentId,
                        filter
                    )
                    .then(function(data) {
                        dispatch({
                            type: 'GRID_FETCH',
                            id: 'safetyPlanDocumentLocationsGrid',
                            items: data.map(function(item) {
                                return {
                                    id: item.locationUuid,
                                    locationName: item.locationName,
                                    isSet: item.isSet
                                };
                            })
                        });
                        var selectedItems = [];
                        data.forEach(function(item) {
                            if (item.isSet == 1) {
                                selectedItems.push(item.locationUuid);
                            }
                        });
                        dispatch({
                            type: 'GRID_SELECT_ALL',
                            id: 'safetyPlanDocumentLocationsGrid',
                            data: selectedItems
                        });
                    });
            };
        }
    };
}